<script lang="ts">
    import {_} from '../services/i18n.js';
    import {createEventDispatcher} from "svelte";

    import Accordion from "./Accordion.svelte";
    import StepContactInfo from "./steps/StepContactInfo.svelte";
    import StepCommunityInfo from "./steps/StepCommunityInfo.svelte";
    import StepCoordinator from "./steps/StepCoordinator.svelte";
    import StepFunding from "./steps/StepFunding.svelte";
    import StepBankDetails from "./steps/StepBankDetails.svelte";;
    import {myStore, entityStore} from "./../stores.js";

    const dispatch = createEventDispatcher();

    export let form:any;

    export let stickySidebar = false;

    function onSubmitBtnClicked(){
        dispatch('submitBtnClicked');
    }
</script>

<div class="form-content" style="padding-bottom:400px;">
    <div style="width:100%">

        <div class="" style="margin-bottom:2rem;">
            <Accordion title={$_('Informations sur la personne de contact')} expanded={$entityStore.steps[0].expanded}  stepKey="step1">
            <div slot="content">
              <StepContactInfo></StepContactInfo>
            </div>
        </Accordion>
        </div>

        <div  style="margin-bottom:2rem;">
        <Accordion title={$_('Adhésion au pacte communal')} expanded={$entityStore.steps[1].expanded} stepKey="step2">
            <div slot="content">
                <StepCommunityInfo  disabledFields={$entityStore.steps[1].disabled} ></StepCommunityInfo>
            </div>
        </Accordion>
        </div>


        <div  style="margin-bottom:2rem;">

            <Accordion title={$_('Coordinateur·trice pacte communal')} expanded={$entityStore.steps[2].expanded}  stepKey="step3">
                <div slot="content">
                    <StepCoordinator  disabledFields={$entityStore.steps[2].disabled} ></StepCoordinator>
                </div>
            </Accordion>

        </div>


    <div  style="margin-bottom:2rem;">
        <Accordion title={$_('Subventions')} expanded={$entityStore.steps[3].expanded} stepKey="step4" >
            <div slot="content">
                <StepFunding  disabledFields={$entityStore.steps[3].disabled} ></StepFunding>
            </div>
        </Accordion>
    </div>

        <div style="margin-bottom:2rem;">
        <Accordion title={$_('Coordonnées bancaires')} expanded={$entityStore.steps[4].expanded}  stepKey="step5">
            <div slot="content">
                <StepBankDetails  disabledFields={$entityStore.steps[4].disabled} ></StepBankDetails>
            </div>
        </Accordion>
        </div>


     <div class="submit-footer-wrapper" style="display:flex; justify-content: flex-end">
         <!--form valid?  {$myStore.isValid} -->
         <button class="mt-2 btn btn-brand submitBtn" type="submit" on:click={onSubmitBtnClicked}>Envoyer</button>


     </div>

    </div>


</div>


<style lang="scss">

   .sticky-bottom-devider{
     height: 295px; //height of website footer, to avoid overflow hidden for static (sticky) sidebar
   }

</style>
